import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { useToast } from "@/components/Toast/useToast";
import Swal from 'sweetalert2';

export default {
  name: 'UploadConsent',
  setup() {
    const { showSuccess, showError, showWarning } = useToast();
    
    return {
      showSuccess,
      showError,
      showWarning
    };
  },

  data: () => ({
      file_input: null,
      uploaded_file: null
    }),
    computed: {
      workflow_id() {
        return this.$store.getters.get_workflow_id;
      }
    },

  methods: {
    browse_file() {
      this.file_input.click();
    },
    on_file_change(event) {
      const FILE = event.target.files[0];
      const MAX_SIZE = 5 * 1024 * 1024;
      if (FILE.size > MAX_SIZE) {
        event.target.value = null;
        this.showWarning('File is too large.');
        return;
      }
      if (FILE.type !== "application/pdf") {
        event.target.value = null;
        this.showWarning('Unsupported file type.');
        return;
      }
      this.uploaded_file = FILE;
    },
    async upload_terms_and_conditions() {
      if (!this.uploaded_file) {
          this.showWarning('Please upload a file.');
          return;
      }
  
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const ENDPOINTS = {
          UPLOAD_TERMS: `${BASE_URL}/verify_api/workflow_management_api/upload_terms_and_conditions_api/${this.workflow_id}`,
          CHECK_STATUS: `${BASE_URL}/verify_api/workflow_management_api/get_workflow_status/${this.workflow_id}`,
          UPDATE_STATUS: `${BASE_URL}/verify_api/workflow_management_api/edit_workflow_api/`
      };
  
      let showSuccessMessage = false; // Default to not showing success message
  
      try {
          // Remove loading modal for better UX
  
          // First check the workflow status
          const statusResponse = await $.ajax({
              url: ENDPOINTS.CHECK_STATUS,
              method: 'GET',
              headers: {
                  Authorization: `Token ${TOKEN}`
              }
          });
  
          // If workflow is approved, show confirmation dialog
          if (statusResponse.status === 'approved') {
              const result = await Swal.fire({
                title: 'Workflow Status Change',
                text: 'This workflow is currently approved. Making changes will set it back to incomplete status. Do you want to continue?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Continue',
                cancelButtonText: 'Cancel',
                reverseButtons: true
              });
              
              if (!result.isConfirmed) {
                  return;
              }
  
              showSuccessMessage = true; // Show success message only when confirming status change
  
              // Update status to incomplete if user confirms
              await $.ajax({
                  url: ENDPOINTS.UPDATE_STATUS,
                  method: 'POST',
                  contentType: 'application/json',
                  data: JSON.stringify({
                      workflow_id: this.workflow_id,
                      status: 'incomplete'
                  }),
                  headers: {
                      Authorization: `Token ${TOKEN}`
                  }
              });
          }
  
          
  
          // Proceed with file upload
          const FORM_DATA = new FormData();
          FORM_DATA.append('terms_and_conditions', this.uploaded_file);
  
          const response = await $.ajax({
              url: ENDPOINTS.UPLOAD_TERMS,
              method: 'POST',
              processData: false,
              contentType: false,
              headers: {
                  Authorization: `Token ${TOKEN}`
              },
              data: FORM_DATA
          });
  
          if (response.status === 'success') {
              $('#terms_and_conditions').modal('hide');
              localStorage.setItem('user_state', 'consent_uploaded');
  
              // Show success message only when confirming status change from approved
              if (showSuccessMessage) {
                  this.showSuccess('Terms and conditions uploaded successfully');
              }
  
              this.$router.push({ name: 'reasons_for_usage' });
          } else {
              throw new Error(response.message || 'Failed to upload terms and conditions');
          }
  
      } catch (error) {
          let error_message = "Something went wrong, please try again";
          if (error.responseJSON?.message) {
              error_message = error.responseJSON.message;
          }
  
          this.showError(error_message);
      }
  },

    async use_verify_terms_and_conditions() {
    const TOKEN = localStorage.getItem('token');
    const BASE_URL = API_BASE_URL;
    const ENDPOINTS = {
        USE_TERMS: `${BASE_URL}/verify_api/workflow_management_api/use_verify_terms_and_conditions/${this.workflow_id}`,
        CHECK_STATUS: `${BASE_URL}/verify_api/workflow_management_api/get_workflow_status/${this.workflow_id}`,
        UPDATE_STATUS: `${BASE_URL}/verify_api/workflow_management_api/edit_workflow_api/`
    };

    let showSuccessMessage = false; // Default to not showing success message

    try {
        // Remove loading modal for better UX

        // First check the workflow status
        const statusResponse = await $.ajax({
            url: ENDPOINTS.CHECK_STATUS,
            method: 'GET',
            headers: {
                Authorization: `Token ${TOKEN}`
            }
        });

        // If workflow is approved, show confirmation dialog
        if (statusResponse.status === 'approved') {
            const result = await Swal.fire({
              title: 'Workflow Status Change',
              text: 'This workflow is currently approved. Making changes will set it back to incomplete status. Do you want to continue?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, Continue',
              cancelButtonText: 'Cancel',
              reverseButtons: true
            });

            if (!result.isConfirmed) {
                return;
            }

            showSuccessMessage = true; // Show success message only when confirming status change

            // Update status to incomplete if user confirms
            await $.ajax({
                url: ENDPOINTS.UPDATE_STATUS,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    workflow_id: this.workflow_id,
                    status: 'incomplete'
                }),
                headers: {
                    Authorization: `Token ${TOKEN}`
                }
            });
        }

        // Proceed with updating terms and conditions
        const response = await $.ajax({
            url: ENDPOINTS.USE_TERMS,
            method: 'POST',
            headers: {
                Authorization: `Token ${TOKEN}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                use_terms_and_conditons_consent: "true"
            })
        });

        if (response.status === 'success') {
            localStorage.setItem('user_state', 'consent_uploaded');
            
            // Show success message only when confirming status change from approved
            if (showSuccessMessage) {
                this.showSuccess(response.message);
            }

            this.$router.push({ name: 'reasons_for_usage' });
        } else {
            throw new Error(response.message || 'Failed to update terms and conditions');
        }

    } catch (error) {
        let error_message = "Something went wrong, please try again";
        if (error.responseJSON?.message) {
            error_message = error.responseJSON.message;
        }
        
        this.showError(error_message);
    }
}
    },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
      this.file_input = this.$refs.file_input;
    },
  }
